import dbsService from "@/services/dbs";

// x-bks-sessionid必須
export const deleteDbsReservation = async () => {
  try {
    await dbsService.apiWithSessionIdWrapper("DELETE", `dbs/reservation`);
  } catch (err) {
    console.log('ERROR"" deleteDbsReservation()');
    throw err;
  }
};
